import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

export const getRestaurant = createAsyncThunk(
  'restaurant/getRestaurant',
  async data => {
    const response = await fetch('https://api.mobrespos.com/get_image', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Accept: 'application/json',
      },
    });
    const restaurantResponse = await response.json();
    console.log('restaurantResponse', restaurantResponse);
    return restaurantResponse;
  },
);

export const restaurantSlice = createSlice({
  name: 'restaurants',
  initialState: {
    restaurant: [],
    isLoading: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getRestaurant.pending, state => {
        state.isLoading = true;
      })
      .addCase(getRestaurant.fulfilled, (state, action) => {
        state.restaurant = action.payload;
        state.isLoading = false;
      })
      .addCase(getRestaurant.rejected, state => {
        state.isLoading = false;
      });
  },
});

export default restaurantSlice.reducer;
